<template>
   <div>
      <div class="row">
         <div class="col-sm-12 col-md-8 col-lg-6 col-centered create-report-card">
            <div class="card p-4">
               <div class="col-centered text-center">
                  <div class="custom-title pt-7">
                     Choose an Analysis you would like to start
                  </div>
                  <div class="custom-subheading pt-3">
                     Externalis gives you the ability to create reports
                     that can be stored And are accessible on the blockchain.
                  </div>
               </div>
               <div class="form-body">
                  <div class="mb-10 pb-7" style="font-family: Exo2-SemiBold;">
                     <div class="container">
                        <div class="row">
                           <a @click="goToComponent('appAnalysisPicInit')" class="col-sm-12 col-md-6 col-lg-4"
                              href="#">
                              <div class="settlement-options-card">
                                 <div class="settlement-options-card-body">
                                    <i class="mdi mdi-camera-enhance c-proof-icon"></i>
                                    <div class="body-2" style="font-family: 'Exo 2'">
                                       PicScan
                                    </div>
                                 </div>
                              </div>
                           </a>
                           <a class="col-sm-12 col-md-6 col-lg-4" href="#">
                              <div class="settlement-options-card disabled-item">
                                 <div class="settlement-options-card-body">
                                    <i class="mdi mdi-file-search c-proof-icon"></i>
                                    <div class="body-2" style="font-family: 'Exo 2'">
                                       CopyScan
                                    </div>
                                 </div>
                              </div>
                           </a>
                           <a class="col-sm-12 col-md-6 col-lg-4" href="#">
                              <div class="settlement-options-card disabled-item">
                                 <div class="settlement-options-card-body">
                                    <i class="mdi mdi-volume-high c-proof-icon"></i>
                                    <div class="body-2" style="font-family: 'Exo 2'">
                                       SoundScan
                                    </div>
                                 </div>
                              </div>
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>

   import {CHANGE_COMPONENT} from '../../core/store/modules/report';

   export default {
      name: "AnalysisInit",
      data() {
         return {
            swap: {}
         };
      },
      methods: {
         goToComponent(component) {
            this.$store.dispatch(CHANGE_COMPONENT, component);
         }
      }
   }
</script>


<style scoped>
   .disabled-item {
      color: #738191 !important;
      cursor: not-allowed !important;
      opacity: 0.5 !important;
      transform: inherit !important;
      border-color: #8c97a4 !important;
   }

   .settlement-options-card {
      display: inline-block;
      cursor: pointer;
      border: 1px solid;
      border-radius: 4px;
      border-color: #8c97a4;
      width: 140px;
      height: 120px;
      position: relative;
      -webkit-transition: .3s ease-in-out;
      transition: .3s ease-in-out;
      color: #738191;
   }

   .settlement-options-card:hover {
      border-color: #82027E;
      color: #82027E;
      -webkit-transition: .2s ease-in-out;
      transition: .2s ease-in-out;
      -ms-transform: scale(.96);
      transform: scale(.96);
   }

   .settlement-options-card-body {
      text-align: center;
      padding-top: 5px;
      cursor: pointer;
      width: 100%;
      height: 100%;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      position: absolute;
   }

   .c-proof-icon {
      font-size: 55px;
      margin-top: -5px;
   }

   .body-2 {
      font-size: 14px;
      letter-spacing: -0.08px;
      line-height: 0;
   }

   i {
      font-size: 1.25rem;
      color: inherit !important;
   }
</style>